import { render, staticRenderFns } from "./hotCourseRank.vue?vue&type=template&id=b6cc3c74&scoped=true"
import script from "./hotCourseRank.vue?vue&type=script&lang=js"
export * from "./hotCourseRank.vue?vue&type=script&lang=js"
import style0 from "./hotCourseRank.vue?vue&type=style&index=0&id=b6cc3c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cc3c74",
  null
  
)

export default component.exports